import { useMemo, useRef } from "react";
import useCurrentUser from "@/hooks/useCurrentUser";
import type { EmulatorRequestOptions } from "./api";

/**
 * Stable emulator API request options. useCurrentUser returns a new
 * getAccessToken identity every render, so route it through a ref — effects
 * and callbacks depending on these options stay stable.
 */
export default function useEmulatorRequestOptions(): EmulatorRequestOptions {
  const { getAccessToken } = useCurrentUser();
  const getAccessTokenRef = useRef(getAccessToken);
  getAccessTokenRef.current = getAccessToken;

  return useMemo(() => ({ getAccessToken: () => getAccessTokenRef.current() }), []);
}
